/**
 * VH-253: the shopping list API client.
 *
 * Seven calls and no list resource, because there is no list object — the list is the
 * caller's unbought rows. Two status codes carry meaning the screen must honour:
 *
 *   422 `nothing_recognised`  the paste yielded nothing — KEEP the text, say so
 *   409 `no_plan_document`    this week has no plan yet (404 would lose the reason,
 *                             see the router's comment)
 */

import { api } from './api'

export const shoppingAPI = {
  list: () => api.get('/api/v1/shopping'),
  addItem: (data) => api.post('/api/v1/shopping/items', data),
  paste: (text) => api.post('/api/v1/shopping/paste', { text }),
  fromPlan: (cycleId) =>
    api.post('/api/v1/shopping/from-plan', cycleId ? { cycle_id: cycleId } : {}),
  // VH-260: one button on a recipe. The version on screen is sent, so a scaled or
  // edited recipe does not put the old amounts on the list.
  fromRecipe: (recipeId, versionId, scale) =>
    api.post('/api/v1/shopping/from-recipe', {
      recipe_id: recipeId,
      ...(versionId ? { version_id: versionId } : {}),
      ...(scale && scale !== 1 ? { scale } : {}),
    }),
  setBought: (id, bought) => api.patch(`/api/v1/shopping/items/${id}`, { bought }),
  remove: (id) => api.delete(`/api/v1/shopping/items/${id}`),
  clearBought: () => api.delete('/api/v1/shopping/bought'),
}

/** The backend's error code for a failed call, or null when it sent none. */
export const errorCode = (error) => {
  const detail = error?.response?.data?.detail
  return typeof detail === 'string' ? detail : null
}
